/* import __COLOCATED_TEMPLATE__ from './optimize-summary-card.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import { action } from '@ember/object';

interface Signature {
  Args: {
    header: string;
    conversationCount?: number;
    summaryText: string;
    attributeLabel?: string;
    handleViewConversations: () => void;
    trackAnalyticsEvent?: (
      action: string,
      object: string,
      extraContext: Record<string, any>,
    ) => void;
    dataTestId?: string;
  };
  Blocks: {
    default: [];
  };
}

export default class OptimizeSummaryCard extends Component<Signature> {
  get firstTopic(): string {
    if (!this.args.attributeLabel) {
      return '';
    }

    return this.args.attributeLabel.split(',')[0].trim();
  }

  get remainingTopicCount(): number {
    if (!this.args.attributeLabel) {
      return 0;
    }

    return this.args.attributeLabel.split(',').length - 1;
  }

  get hasMultipleTopics(): boolean {
    if (!this.args.attributeLabel) {
      return false;
    }

    return this.args.attributeLabel.includes(',');
  }

  @action
  handleConversationButtonClick() {
    this.args.trackAnalyticsEvent?.('conversation-explorer-opened', 'conversation-explorer', {
      conversation_count: this.args.conversationCount,
      topic: this.args.attributeLabel,
      header: this.args.header,
    });
    this.args.handleViewConversations();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::Optimize::OptimizeSummaryCard': typeof OptimizeSummaryCard;
    'reporting/automation/ai-insights/optimize/optimize-summary-card': typeof OptimizeSummaryCard;
  }
}
